import { createRouter, createWebHistory } from "vue-router";
import UserRouter from "@/Routers/UserRouter"
import AdviceRouter from "@/Routers/AdviceRouter"
import PolicyRouter from "@/Routers/PolicyRouters"


const routes = [
  ...UserRouter,
  ...AdviceRouter,
  ...PolicyRouter
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});

export default router